import { render, staticRenderFns } from "./dataExcel.vue?vue&type=template&id=22743f66&"
import script from "./dataExcel.vue?vue&type=script&lang=js&"
export * from "./dataExcel.vue?vue&type=script&lang=js&"
import style0 from "./dataExcel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports